module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/14-14edd9cb1acd6158839ed59795b9e0b7.png";